import * as yup from 'yup';
import docs from './attachments';
import {
  abatimentoDoEmprestimo,
  acessoContraCheque,
  // acessoJornalForluz,
  adiantamentoQuinzenal,
  parcelaAVistaObrigatoria,
  boletoEmprestimoObrigatorio,
  consentimentoDadosSensiveis,
  aceiteInss,
  declaracaoTipoRegime,
  tipoRegime,
  aceite,
  declaracaoVeracidade,
} from './utils/rulesByKey';

export const RMPSchema = (saldoDevedor, usuarioTaesa) => {
  const retiradaVistaRegrasTaesa = usuarioTaesa
    ? {
        retiradaAVista: yup
          .number()
          .float(2, 'Máximo de duas casas decimais após a vírgula')
          .when('parcelaAVista', {
            is: 'Sim',
            then: (field) =>
              field
                .min(0.01, 'Valor deve estar entre 0,01 e 30')
                .max(30, 'Valor deve estar entre 0,01 e 30')
                .required('Atenção, Preencha o Percentual retirada à vista'),
          }),
      }
    : {
        retiradaAVista: yup
          .number()
          .float(2, 'Máximo de duas casas decimais após a vírgula')
          .when('parcelaAVista', {
            is: 'Sim',
            then: (field) =>
              field
                .min(0.01, 'Valor deve estar entre 0,01 e 50')
                .max(50, 'Valor deve estar entre 0,01 e 50')
                .required('Atenção, Preencha o Percentual retirada à vista'),
          }),
      };

  const retiradaMensalRegrasTaesa = usuarioTaesa
    ? {
        retiradaMensal: yup
          .number()
          .float(2, 'Máximo de duas casas decimais após a vírgula')
          .min(
            0.1,
            'Valor não permitido. O percentual tem que estar entre 0.1% e 1%'
          )
          .max(
            1,
            'Valor não permitido. O percentual tem que estar entre 0.1% e 1%'
          )
          .required('Atenção, Preencha o Percentual de retirada mensal'),
      }
    : {
        retiradaMensal: yup
          .number()
          .float(2, 'Máximo de duas casas decimais após a vírgula')
          .min(
            0.5,
            'Valor não permitido. O percentual tem que estar entre 0.5% e 1%'
          )
          .max(
            1,
            'Valor não permitido. O percentual tem que estar entre 0.5% e 1%'
          )
          .required('Atenção, Preencha o Percentual de retirada mensal'),
      };

  if (saldoDevedor) {
    return yup.object({
      ...parcelaAVistaObrigatoria,
      ...abatimentoDoEmprestimo,
      ...retiradaMensalRegrasTaesa,
      ...retiradaVistaRegrasTaesa,
      ...acessoContraCheque,
      // ...acessoJornalForluz,
      ...adiantamentoQuinzenal,
      ...consentimentoDadosSensiveis(),
      ...boletoEmprestimoObrigatorio,
      ...docs.commonsDocs.rules,
      ...aceiteInss,
      ...declaracaoTipoRegime,
      ...tipoRegime,
      ...aceite,
      ...declaracaoVeracidade,
    });
  }

  return yup.object({
    ...parcelaAVistaObrigatoria,
    ...retiradaMensalRegrasTaesa,
    ...retiradaVistaRegrasTaesa,
    ...acessoContraCheque,
    // ...acessoJornalForluz,
    ...adiantamentoQuinzenal,
    ...consentimentoDadosSensiveis(),
    ...docs.commonsDocs.rules,
    ...aceiteInss,
    ...declaracaoTipoRegime,
    ...tipoRegime,
    ...aceite,
    ...declaracaoVeracidade,
  });
};

export const RMPInitialValues = {
  parcelaAVista: '',
  abatimentoDoEmprestimo: '',
  retiradaAVista: '',
  retiradaMensal: '',
  acessoContraCheque: '',
  // acessoJornalForluz: '',
  adiantamentoQuinzenal: '',
  consentimentoDadosSensiveis: false,
  aceiteInss: false,
  boletoEmprestimo: '',
  tipoRegime: '',
  declaracaoTipoRegime: false,
  aceite: false,
  declaracaoVeracidade: false,
  ...docs.commonsDocs.initialValues,
};

export const RMPDocs = {
  commons: docs.commonsDocs.docs,
};
